<section class="section service-area overflow-hidden">
  <div class="image-container ptb_150">
    <div fxLayout="row wrap" class="image-frame">
      <img
        src="https://storage.onindonesia.id/ondelivery.id/trucking/banner_truck.png"
        alt="ONDELIVERY Trucking"
        class="background-image"
        loading="lazy"
        style="z-index:-1;"
      />
      <div class="text-overlay">
        <h1 class="text-white">ONDELIVERY</h1>
        <h1 class="text-white">Trucking</h1>
        <div class="button-custom-padding">
          <a>
            <button mat-raised-button color="primary">Learn More</button>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div fxLayout="row wrap">
    <div class="truck-content">
      <h1>Jenis Layanan</h1>
      <div style="padding-top: 48px">
        <span
          style="
            color: #6b7280;
            font-size: 26px;
            font-family: Poppins;
            font-weight: 400;
            line-height: normal;
          "
          >Dari pengiriman barang dalam jumlah besar menggunakan armada penuh
          atau sebagian seperti pindahan rumah dan kantor<br /><br />
        </span>
        <span
          style="
            color: #6b7280;
            font-size: 26px;
            font-family: Poppins;
            font-weight: 400;
            line-height: normal;
          "
        >
          1. FTL (Full Than Truck Load)<br />
          2. LTL (Less Than Truck Load)
        </span>
      </div>
    </div>
  </div>

  <div fxLayout="row wrap">
    <div class="map-content">
      <img src="assets/img/svgs/indo-map.svg" />
    </div>
  </div>

  <div fxLayout="row wrap">
    <div class="armada-content">
      <div
        style="
          align-self: stretch;
          text-align: center;
          color: #1f2937;
          font-size: 30px;
          font-family: Poppins;
          font-weight: 700;
          word-wrap: break-word;
        "
      >
        Pilihan Armada yang Pas untuk Pengirimanmu
      </div>

      <div class="container">
        <div class="truck-catalog">
          <div class="truck-card" *ngFor="let truck of trucks">
            <div class="truck-cover">
              <h2 class="truck-name">{{ truck.name }}</h2>
            </div>
            <div class="truck-image-container">
              <img [src]="truck.image" alt="{{ truck.name }}" class="truck-image" />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div fxLayout="row wrap">
    <div class="container" style="padding-bottom: 10vh;">
      <footer-banner-one></footer-banner-one>
    </div>
  </div>
</section>

<app-footer-one></app-footer-one>